<template>
  <div class="projectUserReport">
    <Breadtabsheader/>
    <div class="h-piece h-mrt30" style="margin:20px">
      <div class="h-formBox">
        <el-form :inline="true" :model="ruleForm" class="demo-form-inline h-formBorder">
          <div class="h-thirdColumn w-newColumn">
            <el-form-item label="项目名称">
              <el-input v-model="ruleForm.projectName" placeholder="请输入项目名称" clearable></el-input>
            </el-form-item>
            <el-form-item label="项目编码">
              <el-input v-model="ruleForm.id" placeholder="请输入项目编码" clearable></el-input>
            </el-form-item>
            <el-form-item label="客户名称">
              <el-input v-model="ruleForm.customerName" placeholder="请输入名称" clearable></el-input>
            </el-form-item>
            <el-form-item label="订单号">
              <el-input v-model="ruleForm.sapCode" placeholder="请输入订单号" clearable></el-input>
            </el-form-item>
          </div>
          <el-collapse-transition>
            <div v-show="isScreen">
              <div class="h-thirdColumn w-newColumn">
                <el-form-item label="产品型号">
                  <el-input v-model="ruleForm.productName" placeholder="请输入产品型号" clearable></el-input>
                </el-form-item>
                <el-form-item label="产品编码">
                  <el-input v-model="ruleForm.productId" placeholder="请输入产品编码" clearable></el-input>
                </el-form-item>
                <el-form-item label="产品大类" prop="levelCode">
                  <brselectlazy category="product_level" :v="ruleForm.type" v-model="ruleForm.type"
                                :clearable="true"
                                style="width:100%"/>
                </el-form-item>
              </div>
            </div>
          </el-collapse-transition>
        </el-form>
        <div class="l-screenBox">
          <div class="l-screen" @click="collapseChange">
            <img :src="isScreen?closeScreen:drawScreen" alt="">
            <div class="l-screenText">{{isScreen?"收起":"展开"}}</div>
          </div>
          <div class="l-retrieval">
            <el-button class="h-btn h-formBtn" @click="handleFilter">检索</el-button>
            <el-button class="h-btn h-formBtn h-bgwhite" @click="resetData">重置</el-button>
          </div>
        </div>
      </div>
    </div>
    <div class="h-table h-mrt30" style="margin:20px">
      <el-table ref="multipleTable" :data="tableData"
                stripe style="width: 100%"  :border="true" :row-style="cellstyle" max-height="460">
        <el-table-column prop="id" label="项目编码" min-width="160" :show-overflow-tooltip="true" ></el-table-column>
        <el-table-column prop="projectName" label="项目名称" min-width="180" :show-overflow-tooltip="true">
          <template slot-scope="scope">
            <div style="text-align: left;">
              {{scope.row.projectName}}
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="customerName" label="客户名称" min-width="180" :show-overflow-tooltip="true">
          <template slot-scope="scope">
            <div style="text-align: left;">
              {{scope.row.customerName}}
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="toCompanyname" label="用户单位" min-width="180" :show-overflow-tooltip="true">
          <template slot-scope="scope">
            <div style="text-align: left;">
              {{scope.row.toCompanyname}}
            </div>
          </template>
        </el-table-column>
        <el-table-column
                prop="type"
                label="产品大类"
                :show-overflow-tooltip="true"
                width="100">
          <template slot-scope="scope">
            {{scope.row.type.substr(0,3) | dictname('product_level')}}
          </template>
        </el-table-column>

        <el-table-column prop="productName" label="产品型号" min-width="100" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column prop="productId" label="产品编码" min-width="100" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column prop="expectConvertDate" label="预计转化时间" min-width="120" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column prop="productNum" label="申请数量" min-width="100">
          <template slot-scope="scope">
            <div style="text-align: right">
              {{scope.row.productNum}}
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="proNumber" label="订单数量" min-width="100">
          <template slot-scope="scope">
            <div style="text-align: right">
              {{scope.row.proNumber}}
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="installNumber" label="安装数量" min-width="100">
          <template scope="scope">
            <div style="text-align: center; color: #0e77e8;" class="handHover">
              <a @click="clickInstallNumber(scope.row)">{{scope.row.installNumber}}</a>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="serviceTime" label="安装时间" min-width="100" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column prop="sapCode" label="订单号" min-width="100" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column prop="acceptTime" label="签收时间" min-width="100" :show-overflow-tooltip="true"></el-table-column>

      </el-table>
      <div class="h-tableB h-mrt30">
        <div class="h-tableBL" style="margin-left:20px">
          <el-button class="h-btn h-formBtn h-bgblueQ" icon="h-el-icon h-el-icon-import" style="margin-left:-20px;" @click="exportExcel">
            批量导出
          </el-button>
        </div>
        <div class="h-pagination2">
          <pagination :page="ruleForm" @query="query" />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import ss from "../../../api/SystemService";
import updownfile from "../../../utils/updownfile";

export default {
  data(){
    return{
      ruleForm:{
        pageNo: 1,
        pageSize: 10,
        total: 0
      },
      isScreen: false,
      closeScreen:require("@/assets/images/pimg/closeallic.png"),
      drawScreen:require("@/assets/images/pimg/dobleArr.png"),
      tableData: [],
    }
  },
  methods:{
    // 展开折叠
    collapseChange(){
      this.isScreen = !this.isScreen;
    },
    cellstyle(value){
      if(value.row.isClose == '0' && value.row.type == '3'){
        return 'color: #F56C6C;'
      }
    },
    //查询
    handleFilter(){
      this.query();
    },
    //重置
    resetData(){

    },
    query(){
      ss.ProService.selectProListBySh(this.ruleForm).then(rd => {
        console.log(rd, "项目列表");
        console.log('我在这儿呀112', this._user.roles);
        this.ruleForm.total = rd.total;
        this.tableData = rd.records;
        console.log(rd, "================");
      });

    },
    //导出
    exportExcel(){
      updownfile.down("/api/swyl/v1/xiangmu/proMain/getProListByShExcel", this.ruleForm, "get");
    },
    //跳转
    clickInstallNumber(row){
      this.$router.push({
        path: "/bscAfterSalesConfirm",
        query: {sapCode: row.sapCode}
      })
    }
  },

  created() {
    this.query();
  }
}
</script>
<style>

</style>